export const DATA_BATCH_RECEIVED = "DATA_BATCH_RECEIVED";
export const DATA_RECEIVED = "DATA_RECEIVED";
export const DATA_REMOVED = "DATA_REMOVED";
export const SET_DATA_SUBSCRIPTION = "SET_DATA_SUBSCRIPTION";
export const UNSUB_GLOBAL_FEED = "UNSUB_GLOBAL_FEED";
export const RUN_QUEUE = "RUN_QUEUE";
